import React, { useState, useEffect } from 'react';
import './MorningChatbot.css';

const MorningChatbot = ({ user, onNavigate }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [messages, setMessages] = useState([]);
  const [currentStep, setCurrentStep] = useState('greeting');

  // Get username from user object
  const getUserName = (user) => {
    if (!user) return 'there';
    // Use displayName if available, otherwise extract from email
    if (user.displayName) {
      return user.displayName;
    }
    // Fallback to email extraction if no displayName
    const email = user.email;
    if (!email) return 'there';
    const namePart = email.split('@')[0];
    // Convert snake_case, kebab-case, or dot-separated to title case
    return namePart
      .split(/[._-]/)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const userName = getUserName(user);

  useEffect(() => {
    // Initialize with greeting message
    const greetingMessage = {
      id: 1,
      type: 'bot',
      content: `Good morning, ${userName}! 🌅 What would you like to do today?`,
      timestamp: new Date()
    };

    const optionsMessage = {
      id: 2,
      type: 'options',
      options: [
        { id: 'checkin', label: '1. Check-in', action: () => handleOptionSelect('checkin') },
        { id: 'habits', label: '2. Build morning habits', action: () => handleOptionSelect('habits') },
        { id: 'deals', label: '3. See morning deals', action: () => handleOptionSelect('deals') },
        { id: 'feed', label: '4. Go to morning feed', action: () => handleOptionSelect('feed') }
      ],
      timestamp: new Date()
    };

    setMessages([greetingMessage, optionsMessage]);
  }, [userName]);

  const handleOptionSelect = (option) => {
    let responseMessage = '';
    let navigateTo = '';

    switch (option) {
      case 'checkin':
        responseMessage = 'Great! Let\'s get you checked in for today. ⏰';
        navigateTo = 'checkin';
        break;
      case 'habits':
        responseMessage = 'Perfect! Let\'s work on building those morning habits. 💪';
        navigateTo = 'habits';
        break;
      case 'deals':
        responseMessage = 'Awesome! Check out these amazing morning deals. 🛍️';
        navigateTo = 'deals';
        break;
      case 'feed':
        responseMessage = 'Excellent choice! Here\'s your morning feed. 📖';
        navigateTo = 'feed';
        break;
      default:
        responseMessage = 'I\'m not sure what you mean. Let\'s try again!';
    }

    const botResponse = {
      id: Date.now(),
      type: 'bot',
      content: responseMessage,
      timestamp: new Date()
    };

    setMessages(prev => [...prev, botResponse]);

    // Navigate after a short delay
    if (navigateTo) {
      setTimeout(() => {
        onNavigate(navigateTo);
        // Close chatbot after navigation
        setIsOpen(false);
      }, 1500);
    }
  };

  const toggleChatbot = () => {
    setIsOpen(!isOpen);
  };

  if (!isOpen) {
    return (
      <div className="morning-chatbot-closed" onClick={toggleChatbot}>
        <div className="chatbot-icon">
          <i className="fas fa-comments"></i>
        </div>
        <div className="chatbot-label">Hey. How's your morning</div>
      </div>
    );
  }

  return (
    <div className="morning-chatbot">
      <div className="chatbot-header">
        <div className="chatbot-title">
          <i className="fas fa-sun"></i>
          Morning Assistant
        </div>
        <button className="chatbot-close" onClick={toggleChatbot}>
          <i className="fas fa-times"></i>
        </button>
      </div>

      <div className="chatbot-messages">
        {messages.map(message => (
          <div key={message.id} className={`message ${message.type}`}>
            {message.type === 'bot' && (
              <div className="message-content">
                {message.content}
              </div>
            )}
            {message.type === 'options' && (
              <div className="options-container">
                {message.options.map(option => (
                  <button
                    key={option.id}
                    className="option-button"
                    onClick={option.action}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MorningChatbot;